import React, { useEffect, useState, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import Dropdown from 'react-bootstrap/Dropdown'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import PaymentsListModal from '../../modals/PaymentsListModal';
import { Accordion, AccordionTab } from 'primereact/accordion';
import StoreInfo from '../../parts/StoreInfo';
import FormContext from '../../../services/formContext';
import { MdHandyman } from "react-icons/md";

export default function SalesOrderView (){
    const {
        account
    } = useContext(FormContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', 'PHP');
    const tax_enabled = helpers.getSettingValue(account?.settings, 'tax_enabled', 1);
    const discount_enabled = helpers.getSettingValue(account?.settings, 'discount_enabled', 1);
    const single_label = helpers.getSettingValue(account?.settings, 'sales_order_single_label', 'Sales Order');
    const plural_label = helpers.getSettingValue(account?.settings, 'sales_order_plural_label', 'Sales Order');
    const heading_label = `Manage ${plural_label}`;
    const invoice_label = helpers.getSettingValue(account?.settings, 'invoice_single_label', 'Invoice');
    const page_title = `${single_label} Details`;

    const { order_id } = useParams();
    const [loading, setLoading] = useState(1);
    //const [page_title, setPageTitle] = useState(`${single_label} Details`);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(store.sales_order_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [invoice_table, setInvoiceTable] = useState([]);
    const navigate = useNavigate();
    
   
    useEffect(() => {
        initTreeView()
        if(order_id){
            getData(order_id)
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    useEffect(() => {
        displayInvoiceItems()
    }, [record_data]);

    function getData(order_id){
        if(!order_id){
            return
        }
        const url = helpers.createUrl(`V1/manage/order/sales/${order_id}?store_id=${helpers.getStoreID()}`)
        
        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.order_date = new Date(res.order_date)

            setLoading(0)
            setRecordData(items)
            setRecordItems(items.items)
            setRecordLoaded(1)
        })
        .catch((err) => {
            setLoading(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/sales/list");
                }
            })
        }); 

    }
    function computeSubTotals(){
        let items = 0;
        let total_amount = 0

        record_items.forEach((data) => {
            const quantity = parseInt(data.quantity ?? '0', 10);
            const price = parseFloat(data.amount ?? '0');
            const discount = parseFloat(data.discount_amount ?? '0');

            const totalPrice = price * quantity
            const netPrice = totalPrice - discount;

            items += quantity;
            total_amount += netPrice
        });

        return helpers.formatCurrencyAmount(total_amount, default_currency);
    }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>
                        <div className='mb-0'>{data.product_name}{data.product_variant_name != 'Generic' ? ` (${data.product_variant_name})` : ''}</div>
                        {data.product_description ? <div className='mt-2' style={{whiteSpace: 'pre-line', maxHeight: '150px', overflow: 'auto', fontSize: '12px'}}>{data.product_description}</div> : ''}
                    </td>
                    <td>{data.product_code}</td>
                    <td>{data.quantity}{data.unit_name ? <small> {data.unit_name}</small> : ''}</td>
                    <td>{data.fulfilled_quantity}/{data.quantity}</td>
                    <td>{data.returned_quantity}</td>
                    <td>{helpers.formatCurrencyAmount(data.amount, default_currency)}</td>
                    {parseInt(discount_enabled) ? 
                    <td>
                        {helpers.formatCurrencyAmount(data.discount_amount, default_currency)}<br/>
                        <small>{data.discount_name ? `(${data.discount_name})` : ''}</small>
                    </td> : ''
                    }
                    <td>{helpers.formatCurrencyAmount(data.total_amount, default_currency)}</td>
                </tr>)

            })
        }

        setTableItems(<tbody>{items}</tbody>)
    }

    function displayInvoiceItems(){
        if (Object.entries(record_data.invoice).length) {
            let items = []
            const invoice = record_data.invoice
            items = <tr>
                        <td>{invoice.invoice_date}</td>
                        <td><Link to={`/invoices/${invoice.id}`} target='_blank'>{invoice.invoice_no}</Link></td>
                        <td>{invoice.due_date}</td>
                        <td>{helpers.formatCurrencyAmount(invoice.total_amount, default_currency)}</td>
                        <td>{helpers.formatCurrencyAmount(invoice.balance_amount, default_currency)}</td>
                        <td>{invoice.invoice_status}</td>
                        <td width={20}>
                            <div  className='text-center'>
                            <Dropdown as={ButtonGroup} drop="down" className='mr-sm-2' size="sm" >
                                <Dropdown.Toggle variant="outline-dark" id="dropdown-split-basic" />
                                <Dropdown.Menu>
                                    <Dropdown.Item href={`/invoices/${invoice.id}/payment`} target='_blank'><i className="fas fa-credit-card mr-2" style={{width: '20px'}} />Add Payment</Dropdown.Item>
                                    <Dropdown.Item href={`/invoices/${invoice.id}/print`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                    <Dropdown.Item onClick={(e) => triggerAction(invoice.id, 'single-delete')} className='text-danger'><i className="fas fa-trash mr-2" style={{width: '20px'}} />Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            </div>
                        </td>
                    </tr>

            setInvoiceTable(<div className="container mb-3">
                <Accordion>
                    <AccordionTab header={invoice_label} className="text-dark">
                        <div className='table-responsive-md'>
                        <table className="table table-sm mb-0">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Reference #</th>
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Balance</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>{items}</tbody>
                        </table>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>)
        }
    }

    function triggerAction(data, action = '', order_id = '', status = ''){
        if(!action) return;

        if(action === 'create-service'){
            createServiceRequest(data)
            return
        }
        if(action === 'force-fulfillment'){
            forceFulfillment(data, 'fulfill')
            return;
        }
        else if(action === 'redo-fulfillment'){
            forceFulfillment(data, 'redo')
            return;
        }
        else if(action === 'instant-invoice'){
            createInvoice(data)
            return;
        }
        else if(action === 'open'){
            updateStatusItem(1)
        }
        else if(action === 'confirm'){
            updateStatusItem(2)
        }
        else if(action === 'single-delete' || action === 'bulk-delete'){
            let ids = [];
            ids.push(data)

            let title = 'Delete Invoice'

            Swal.fire({
                title: title,
                text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
                showCancelButton: true,
                showConfirmButton: false,
                closeOnCancel: true,
                showDenyButton: true,
                denyButtonText: 'Yes'
            })
            .then((result) => {
                if (result.isDenied) {
                    deleteItem(ids)
                }
            })
        }

        //updateStatusItem(order_id, status)
    }

    function deleteItem(id){
        const url = helpers.createUrl('V1/manage/invoices/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "invoice_ids": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function forceFulfillment(id, action = ''){
        const url = helpers.createUrl(`V1/manage/order/sales/${id}/fulfillment`)
        httpRequest(url, 'POST', {
            postdata: {
                "action": action,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 

    }

    function updateStatusItem(status_id){
        const url = helpers.createUrl('V1/manage/order/sales/status')
        httpRequest(url, 'POST', {
            postdata: {
                "order_id": order_id,
                "store_id": helpers.getStoreID(),
                "status_id": status_id
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK"
                })
            }); 
    }

    function createInvoice(id){
        const url = helpers.createUrl('V1/manage/order/sales/invoice')
        httpRequest(url, 'POST', {
            postdata: {
                "order_id": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 

    }

    function createServiceRequest(id){
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/create-from-orders`)
        setLoading(1)
        httpRequest(endpoint, 'POST', {
            postdata: {
                "reference_id": id,
                "reference_type": 'sales-order'
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/polarserv/service-requests/${res?.data?.id}/form`);
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    return (
        <>
        <PaymentsListModal show_modal={payments_modal} id={order_id} close_modal={setPaymentsModal} />
        <Layout page_title={page_title} menu="manage-sales" breadcrumbs={true} parent_link='/sales/list' parent_text={heading_label}>
                <div className="content" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div order_id="so-customer-section" className="col-lg-12">
                                    {record_loaded ?
                                    <div className='border rounded p-3 mb-3 d-flex justify-content-between align-items-center'>

                                        <h5 className='mb-0 mb-md-0 d-flex'>{record_data.order_no}</h5>

                                        <div className='d-sm-flex flex-column flex-sm-row d-none'>
                                            <Dropdown as={ButtonGroup} drop="down" className='mr-sm-2' >
                                                <Dropdown.Toggle variant="outline-dark" id="dropdown-split-basic" />
                                                <Dropdown.Menu>
                                                    {
                                                    parseInt(record_data.order_status_id) !== 1 ?
                                                        <Dropdown.Item onClick={(e) => triggerAction(order_id, 'create-service')}><MdHandyman size={25} className='mr-2' />Create Service Request</Dropdown.Item> : ''
                                                    }

                                                    {
                                                    parseInt(record_data.order_status_id) !== 1 && 
                                                    (parseInt(record_data.shipping_status_id) === 1 || parseInt(record_data.shipping_status_id) === 2 || parseInt(record_data.shipping_status_id) === 3) ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'force-fulfillment')}><i className="fas fa-shipping-fast mr-2" style={{width: '20px'}} />Force Fulfillment</Dropdown.Item> : ''
                                                    }

                                                    {
                                                    record_data.force_fulfillment ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'redo-fulfillment')}><i className="fas fa-redo mr-2" style={{width: '20px'}} />Redo Force Fulfillment</Dropdown.Item> : ''
                                                    }

                                                    {
                                                    parseInt(record_data.order_status_id) === 1 ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'confirm', 2)}><i className="fas fa-check-circle mr-2" style={{width: '20px'}} />Set as Confirm</Dropdown.Item> : ''
                                                    }
        
                                                    {
                                                    parseInt(record_data.order_status_id) === 2 && parseInt(record_data.shipping_status_id) === 1 ?
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'open', 1)}><i className="fas fa-file-alt mr-2" style={{width: '20px'}} />Set as Open</Dropdown.Item> : ''
                                                    }

                                                    {
                                                        parseInt(record_data.order_status_id) !== 3 && parseInt(record_data.order_status_id) !== 4 ?
                                                        <Dropdown.Item as={Link} to={`/sales/${order_id}/edit`}><i className="fas fa-pencil-alt mr-2" style={{width: '20px'}} />Edit</Dropdown.Item>:''
                                                    }

                                                    <Dropdown.Item href={`/sales/${order_id}/print`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            
                                            {
                                            parseInt(record_data.order_status_id) === 2 || (parseInt(record_data.shipping_status_id) !== 1 && parseInt(record_data.shipping_status_id) !== 2) ?
                                            <Dropdown as={ButtonGroup} drop="down" className='mr-sm-2' >
                                                <Dropdown.Toggle variant="outline-primary" id="dropdown-split-basic">
                                                    Create
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>

                                                    {   
                                                        parseInt(record_data.order_status_id) === 2 ? 
                                                        <Dropdown.Item onClick={(e) => triggerAction(order_id, 'instant-invoice')}><i className="fas fa-file-invoice mr-2" style={{width: '20px'}} />Invoice</Dropdown.Item>:''
                                                    }
                                                    
                                                    {
                                                        parseInt(record_data.shipping_status_id) !== 1 && parseInt(record_data.shipping_status_id) !== 2 ?
                                                        <Dropdown.Item as={Link} to={`/sales/${order_id}/sales-return`}><i className="fas fa-sign-in-alt mr-2" style={{width: '20px'}} />Sales Return</Dropdown.Item> : ''
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown> : ''
                                            }

                                            <Link className='btn btn-dark' to="/sales/list">Cancel</Link>  
                                        </div>

                                        <div className='d-block d-sm-none'>
                                            <Dropdown as={ButtonGroup} drop="down-right" className='mr-sm-2'>
                                                <Dropdown.Toggle variant="dark" id="dropdown-split-basic" />
                                                <Dropdown.Menu>
                                                    {
                                                    parseInt(record_data.order_status_id) !== 1 ?
                                                        <Dropdown.Item onClick={(e) => triggerAction(order_id, 'create-service')}><MdHandyman size={25} className='mr-2' />Create Service Request</Dropdown.Item> : ''
                                                    }
                                                    
                                                    {   
                                                        parseInt(record_data.order_status_id) === 2 ? 
                                                        <Dropdown.Item onClick={(e) => triggerAction(order_id, 'instant-invoice')}><i className="fas fa-file-invoice mr-2" style={{width: '20px'}} />Create Invoice</Dropdown.Item>:''
                                                    }

                                                    {
                                                    parseInt(record_data.order_status_id) !== 1 && 
                                                    (parseInt(record_data.shipping_status_id) === 1 || parseInt(record_data.shipping_status_id) === 2 || parseInt(record_data.shipping_status_id) === 3) ?
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'force-fulfillment')}><i className="fas fa-shipping-fast mr-2" style={{width: '20px'}} />Force Fulfillment</Dropdown.Item> : ''
                                                    }

                                                    {
                                                    record_data.force_fulfillment ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'redo-fulfillment')}><i className="fas fa-redo mr-2" style={{width: '20px'}} />Redo Force Fulfillment</Dropdown.Item> : ''
                                                    }
                                                    
                                                    <Dropdown.Item as={Link} to={`/sales/${order_id}/sales-return`}><i className="fas fa-sign-in-alt mr-2" style={{width: '20px'}} />Sales Return</Dropdown.Item>
                                                    
                                                    <Dropdown.Divider />
                                                    {
                                                    parseInt(record_data.shipping_status_id) !== 4 ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction('force-fulfillment', order_id, 4)}><i className="fas fa-shipping-fast mr-2" style={{width: '20px'}} />Set as Shipment Fulfilled</Dropdown.Item> : ''
                                                    }

                                                    {
                                                    parseInt(record_data.order_status_id) === 1 ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'confirm', 2)}><i className="fas fa-check-circle mr-2" style={{width: '20px'}} />Set as Confirm</Dropdown.Item> : ''
                                                    }
        
                                                    {
                                                    parseInt(record_data.order_status_id) === 2 && parseInt(record_data.shipping_status_id) === 1 ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'open', 1)}><i className="fas fa-file-alt mr-2" style={{width: '20px'}} />Set as Open</Dropdown.Item> : ''
                                                    }

                                                    {
                                                        parseInt(record_data.order_status_id) !== 3 && parseInt(record_data.order_status_id) !== 4 ?
                                                        <Dropdown.Item as={Link} to={`/sales/${order_id}/edit`}><i className="fas fa-pencil-alt mr-2" style={{width: '20px'}} />Edit</Dropdown.Item> : ''
                                                    }

                                                    <Dropdown.Item href={`/sales/${order_id}/print`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div> : ''}
                                </div>
                            </div>
                    </div>

                    {
                        invoice_table
                    }

                            
                    <div className="container">
                        {
                            record_loaded ?
                            <div className="invoice p-4 mb-3">
                                <div className="d-flex justify-content-between mb-3">
                                    <StoreInfo store={record_data.store_info} />

                                    <div className='text-right'>
                                        <h2><strong>{helpers.capitalizeString(single_label)}</strong></h2>
                                        <h5>{helpers.displayOrderStatusBadge(record_data.order_status_id, record_data.order_status)}</h5>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-4 mb-3">
                                        <h5 className='mb-0'><b>Bill To:</b></h5>
                                        <div>
                                            <p className='mb-0'><b>{record_data.customer_name}</b></p>
                                            <p className='mb-0'>{record_data.billing_address}</p>
                                            <p className='mb-0'>{record_data.billing_phone}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <h5 className='mb-0'><b>Ship To:</b></h5>
                                        <div>
                                            <p className='mb-0'><b>{record_data.shipping_contact_name}</b></p>
                                            <p className='mb-0'>{record_data.shipping_address}</p>
                                            <p className='mb-0'>{record_data.shipping_phone}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 text-lg-right mb-2">
                                        <table className='table table-borderless table-sm'>
                                            <tbody>
                                                <tr>
                                                    <td className='py-0'><b>Reference #:</b></td>
                                                    <td className='py-0'>{record_data.order_no ? record_data.order_no : '---'}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Date:</b></td>
                                                    <td className='py-0'>{helpers.formatDate(record_data.order_date)}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Terms:</b></td>
                                                    <td className='py-0'>{record_data.payment_term ? record_data.payment_term : '---'}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Shipment:</b></td>
                                                    <td className='py-0'>{record_data.shipping_status ? record_data.shipping_status : '---'}</td>
                                                </tr>
                                                {
                                                    record_data.order_status_id == 4
                                                    ?
                                                    <tr>
                                                        <td className='py-0'><b>Reason:</b></td>
                                                        <td className='py-0'>{record_data.reason}</td>
                                                    </tr> : ''
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className='table table-striped table-sm border-bottom'>
                                        <thead>
                                            <tr>
                                                <th>Item</th>
                                                <th>SKU</th>
                                                <th>Quantity</th>
                                                <th>Fulfillment</th>
                                                <th>Returned</th>
                                                <th>Price</th>
                                                {parseInt(discount_enabled) ? <th>Discount</th> : ''}
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        {
                                            table_items
                                        }
                                    </table>
                                </div>

                                <div className='row'>
                                    <div className="col-lg-7 d-flex align-items-center">{record_data.customer_notes ? <p className='pt-1 pt-lg-4'>{record_data.customer_notes}</p>:''}</div>
                                    <div className="col-lg-5 mb-0 border p-2">
                                        <table className='table table-sm table-borderless mb-0'>
                                            <tbody>
                                                <tr>
                                                    <td className='border-top-0'><b>Sub Total</b></td>
                                                    <td className='border-top-0'>{computeSubTotals()}</td>
                                                </tr>
                                                {parseInt(discount_enabled) ?
                                                <tr>
                                                    <td><b>Total Discount</b></td>
                                                    <td>{parseFloat(record_data.total_discount) > 0 ? helpers.formatCurrencyAmount(record_data.total_discount, default_currency) : '---'}</td>
                                                </tr> : ''
                                                }
                                                <tr>
                                                    <td><b>Shipping Fee</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.shipping_fee, default_currency)}</td>
                                                </tr>
                                                {parseInt(tax_enabled) ?
                                                <tr>
                                                    <td><b>Total Tax</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.total_tax, default_currency)}</td>
                                                </tr> : ''
                                                }
                                                <tr className='bg-dark'>
                                                    <td><b>Total</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.total_amount, default_currency)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            : 
                            <div className="invoice p-5 mb-3">
                                <h4>&nbsp;</h4>
                            </div>
                        }
                    </div>
                </div>
        </Layout>
        </>
    )
}